import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { IPayrollShuttleEntry } from "../../interface/payrollShuttle";

export const generatePayrollShuttle = async (
    year: number,
    month: number,
    token: string,
    setEntries: (entries: IPayrollShuttleEntry[]) => void,
    dispatch: Function,
    setError: Function
) => {
    try {
        const response = await axios.post(
            `${urlAPI}/payroll-shuttle/generate`,
            { year, month },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        setEntries(response.data.message);
        dispatch(showSnackbar("Navette de paie générée avec succès.", "success"));
    } catch (error: any) {
        console.error(error);
        setError("Impossible de générer la navette de paie.");
        dispatch(showSnackbar("Erreur lors de la génération de la navette de paie.", "error"));
    }
};
